import { render, staticRenderFns } from "./StockUnitList.vue?vue&type=template&id=1090211d&scoped=true"
import script from "./StockUnitList.vue?vue&type=script&lang=js"
export * from "./StockUnitList.vue?vue&type=script&lang=js"
import style0 from "./StockUnitList.vue?vue&type=style&index=0&id=1090211d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1090211d",
  null
  
)

export default component.exports